type VipBgImage = {
  src: string;
  alt: string;
  width: number;
  height: number;
};

export type VipConfig = {
  name: string;
  description: string;
  background: VipBgImage;
  link: string;
};

export const VIP_CONFIGS: VipConfig[] = [
  {
    name: 'WITTCHEN',
    description: 'vip.descriptions.wittchen',
    background: {
      src: '/img/vip/wittchen.jpg',
      alt: '',
      height: 346,
      width: 620,
    },
    link: 'wittchen',
  },
  {
    name: '4F',
    description: 'vip.descriptions.4f',
    background: {
      src: '/img/vip/4f.jpg',
      alt: '',
      width: 346,
      height: 620,
    },
    link: '4f',
  },
  {
    name: 'SKLEP BIEGACZA',
    description: 'vip.descriptions.sklepbiegacza',
    background: {
      src: '/img/vip/sklep-biegacza.jpg',
      alt: '',
      width: 346,
      height: 620,
    },
    link: 'sklep-biegacza',
  },
  {
    name: 'R-GOL.COM',
    description: 'vip.descriptions.rGol',
    background: {
      src: '/img/vip/rGol.jpg',
      alt: '',
      width: 346,
      height: 620,
    },
    link: 'r-gol',
  },
];
